import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
  memo,
  forwardRef,
  useImperativeHandle,
} from "react";
import BasicInfo from "./BasicInfo";
import ProductItem from "./ProductItem";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  tableCellClasses,
  Card,
  CardContent,
  FormGroup,
  IconButton,
  AppBar,
  Toolbar,
  Icon,
  Radio,
  Alert,
  StepButton,
  MenuItem,
  Stack,
  Switch,
  Chip,
  useTheme
} from "@mui/material";
import ListPageHeader from "../../utilities/ListPageHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import PRJOrderSummary from "./PRJOrderSummary";
import { Formik, Form, Field } from "formik";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import {
  checkBlankSpace,
  checkNumber,
  checkSpecialChar,
  checkString,
} from "../../utilities/FormValidation";
import FormPageHeader from "../../utilities/FormPageHeader";
import jwtDecode from "jwt-decode";
import { m } from "framer-motion";
import OrderSuccess from "./OrderSuccess";
import ProjectOverview from "./ProjectOverview";
import { useFormik } from "formik";
import * as Yup from "yup";

const newOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newCustomerOrder}`;
const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRanges}`;
const colorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllHandlesByVendor}`;
const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllCarcassByVendor}`;

const TestOrder = (props) => {
  const { mode } = props;
  const { id } = useParams();
  const theme = useTheme();
  const navigate = useNavigate();
  const [orderCategoryValue, setOrderCategoryValue] = useState();
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [customerId, setCustomerId] = useState();
  const [customerName, setCustomerName] = useState("");
  const [showroom, setShowroom] = useState(null);
  const [product, setProduct] = useState();
  const [orderReference, setOrderReference] = useState("");
  const [WG1Price, setWG1Price] = useState("");
  const [WG2Price, setWG2Price] = useState("");
  const [volume, setVolume] = useState();
  const [weight, setWeight] = useState();
  const [showroomOptions, setShowroomOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [formValues, setFormValues] = useState([
    {
      range: {},
      priceGroup: {},
      color: {},
      carcass: {},
      handle: {},
    },
  ]);
  const [selectedRange, setSelectedRange] = useState({});
  const [color, setColor] = useState([]);
  const [range, setRange] = useState([]);
  const [priceGroup, setPriceGroup] = useState([]);
  const [handles, setHandles] = useState([]);
  const [carcass, setCarcass] = useState([]);

  const getNewOrder = async () => {
    try {
      let list = await OAuthService.getList(newOrderUrl);
      let newOrder = list.data;
      const products = newOrder?.products.map((value) => {
        return {
          label: value.name,
          value: value.shortKey,
          id: value.id,
        };
      });
      const showrooms = Object.keys(newOrder?.showrooms).map((key) => ({
        value: key,
        label: newOrder.showrooms[key],
      }));
      const filterOrderCategory = newOrder?.orderCategories.filter(
        (item) => item.name !== "SAM"
      );
      const orderCategories = filterOrderCategory.map((value) => {
        return { label: `${value.displayName}`, value: value.name };
      });
      setShowroom({
        value: newOrder?.showroomId,
        label: newOrder?.showroomName,
      });
      setProductOptions(products);
      setShowroomOptions(showrooms);
      setCustomerName(newOrder?.companyName);
      setCustomerId(newOrder?.partnerCompany);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    getNewOrder();
    // getProjectForeCastList();
  }, []);

  useEffect(() => {
    if (mode === "new") {
      setProduct();
      setOrderCategoryValue();
      setWG1Price("");
      setWG2Price("");
      setVolume("");
      setWeight("");
      setFormValues([
        {
          range: {},
          priceGroup: {},
          color: {},
          carcass: {},
          handle: {},
        },
      ]);
    }
  }, [mode === "new"]);

  const placeOrder = () => {
    return (
      <>
        {activeStep !== 0 && (
          <Button
            color="inherit"
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            Back
          </Button>
        )}
        <Button variant="contained" color="primary" onClick={handleNext}>
          {activeStep === steps.length - 1 ? "Submit" : "Next"}
        </Button>
      </>
    );
  };

  const steps = ['Step 1', 'Step 2', 'Step 3'];

  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState(Array(steps.length).fill({}))

  const handleNext = async () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmit = () => {
    console.log('Form Data', formData)
    console.log('Additional form values', formValues)
  }

  const handleInputChange = (field, value) => {
    setFormData((prevData) => {
      const newData = [...prevData];
      newData[activeStep] = { ...newData[activeStep], [field]: value }
      return newData;
    })
  }
  const handleSelectChange = (index, value) => {
    setFormValues((prevValues) => {
      const newValues = [...prevValues]
      newValues[index] = { ...newValues[index], range: value, priceGroup: value, color: value, carcass: value, handle: value }
      return newValues;
    })
  }

  let addFormFields = () => {
    if (formValues.length < 3) {
      setFormValues([
        ...formValues,
        { range: {}, priceGroup: {}, color: {}, carcass: {}, handle: {} },
      ]);
    }
  };
  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };
  const handleRangeChange = (data, index, field) => {
    const newVals = formValues; //[index];
    newVals[index][field] = { value: data.value, label: data.label }; // data.value;
    setSelectedRange({ value: data.value, label: data.label, id: data.id });
    if (field === "range") {
      newVals[index]["color"] = {}; // data.value;
      newVals[index]["priceGroup"] = { value: data.priceGroup, label: data.priceGroup }; // data.value;
      OAuthService.getList(`${colorUrl}/${data.id}/variations`)
        .then((list) => {
          const rangeVariations = list.data?._embedded?.rangeVariations;
          const colors = color;
          colors[index] = rangeVariations?.map((variations) => ({
            value: variations.productId,
            label: `${variations.productId}-${variations.productName}`,
          }));
          setColor((prev) => [...colors]);
        })
        .catch((err) => setError(err.message));
    }
    setFormValues((prev) => [...newVals]);
  };

  const getRangeList = async () => {
    OAuthService.getList(`${rangeUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const ranges = list.data;
        setRange(
          ranges?.map((range) => ({
            value: range?.productId,
            label: `${range?.priceGroup?.pgId}-${range?.productName}`,
            id: range.id,
            priceGroup: range?.priceGroup?.pgId,
          }))
        );
      })
      .catch((err) => setError(err.message));
  };

  const getHandleList = async () => {
    OAuthService.getList(`${handleUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { handles } = list.data?._embedded;
        setHandles(
          handles?.map((handle) => ({
            value: handle.productId,
            label: `${handle.productId}-${handle.productName}`,
          }))
        );
      })
      .catch((err) => setError(err.message));
  };

  const getCarcassList = async () => {
    OAuthService.getList(`${carcassUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { carcasses } = list.data?._embedded;
        setCarcass(
          carcasses?.map((carcasse) => ({
            value: carcasse.productId,
            label: `${carcasse.productId}-${carcasse.productName}`,
          }))
        );
      })
      .catch((err) => setError(err.message));
  };

  useEffect(() => {
    if (product) {
      getRangeList();
      getHandleList();
      getCarcassList();
    }
  }, [product]);

  return (
    <>
      <FormPageHeader
        componentName="Create Order"
        pageName="Create Order"
        currentPage={
          mode === "edit"
            ? "Edit Order"
            : mode === "new-type"
              ? "Create Type Order"
              : "Create Order"
        }
        orderHeaderAction={placeOrder()}
        successMsg={successMsg}
        snackState={snackState}
        error={error}
      >
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label, index) => (
            <Step key={index}>
              <StepButton color="inherit">
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </FormPageHeader>
      <div className="px-20">
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: `1px dashed ${theme.palette.divider}`, borderRadius: 4 }}
            >
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <label className="pb-8 block">Customer</label>
                  <TextField
                    name="customer"
                    fullWidth
                    variant="outlined"
                    type="text"
                    value={customerName}
                    disabled
                  />
                </Grid>
                <Grid item xs={6}>
                  <label className="pb-8 block">*Showroom</label>
                  <Select
                    value={showroom}
                    onChange={(event) =>
                      setShowroom({ value: event.value, label: event.label })
                    }
                    name="showroom"
                    options={showroomOptions}
                    styles={customStyles()}
                    className="select"
                  />
                </Grid>
              </Grid>
            </Box>
            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: `1px dashed ${theme.palette.divider}`, borderRadius: 4 }}
            >
              <Grid container xs={12} spacing={2}>
                <Grid item xs={6}>
                  <label className="pb-8 block">*Volume(cbm)</label>
                  <TextField
                    value={formData[activeStep]?.volume || ''}
                    onChange={(e) => handleInputChange('volume', e.target.value)}
                    name="volume"
                    fullWidth
                    variant="outlined"
                    type="number"
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <label className="pb-8 block">Weight (kg)</label>
                  <TextField
                    value={formData[activeStep]?.weight || ''}
                    onChange={(e) => handleInputChange('weight', e.target.value)}
                    name="weight"
                    fullWidth
                    variant="outlined"
                    type="number"
                  />
                </Grid>
              </Grid>
            </Box>
            <Box
              className="shadow mb-20 mt-20"
              sx={{
                backgroundColor: theme.palette.background.paper,
                p: 2,
                position: "relative",
                borderRadius: "1.6rem",
                borderBottomRightRadius: 0,
                mb: 2.5,
                width: "100%",
              }}
            >
              {formValues.map((element, index) => (
                <>
                  <Grid
                    container
                    xs={12}
                    spacing={2}
                    className={index ? "mt-4 relative" : "relative"}
                  >
                    <Grid item xs={3}>
                      <label className="pb-8 flex">Range</label>
                      <Select
                        value={element.range}
                        onChange={(e) => handleSelectChange(index, { value: e.value, label: e.label })}
                        name="range"
                        options={range}
                        styles={customStyles()}
                        className="w-full"
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <label className="pb-8 flex">Color</label>
                      <Select
                        value={formValues?.[index]?.color}
                        onChange={(e) => handleSelectChange(e, index, "color")}
                        name="color"
                        options={color[index]}
                        styles={customStyles()}
                        className="w-full"
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <label className="pb-8 flex">Carcass</label>
                      <Select
                        value={formValues?.[index]?.carcass}
                        onChange={(e) => handleSelectChange(e, index, "carcass")}
                        name="carcass"
                        options={carcass}
                        styles={customStyles()}
                        className="w-full"
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <label className="pb-8 flex">Handle</label>
                      <Select
                        value={formValues?.[index]?.handle}
                        onChange={(e) => handleSelectChange(e, index, "handle")}
                        name="handle"
                        options={handles}
                        styles={customStyles()}
                        className="w-full"
                      />
                    </Grid>
                    {index ? (
                      <IconButton
                        color="secondary"
                        onClick={() => removeFormFields(index)}
                        sx={{ position: "absolute", right: "-30px", bottom: 4 }}
                      >
                        <FuseSvgIcon size={14}>heroicons-outline:x</FuseSvgIcon>
                      </IconButton>
                    ) : null}
                  </Grid>
                </>
              ))}
              {formValues.length < 3 && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => addFormFields()}
                  size="small"
                  sx={{
                    position: "absolute",
                    bottom: "-32px",
                    right: 0,
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 0,
                  }}
                >
                  <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
                </Button>
              )}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: `1px dashed ${theme.palette.divider}`, borderRadius: 4 }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <label className="pb-8 block">*Product</label>
                  <Select
                    value={product}
                    onChange={(event) => {
                      setProduct({
                        value: event.value,
                        label: event.label,
                        id: event.id,
                      });
                    }}
                    name="product"
                    options={productOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Grid>
                <Grid item xs={3}>
                  <label className="pb-8 block">Order Reference</label>
                  <TextField
                    value={orderReference}
                    name="orderReference"
                    fullWidth
                    variant="outlined"
                    type="text"
                    disabled
                  />
                </Grid>
              </Grid>
            </Box>
            <Box
              className="mb-20 mt-20"
              sx={{ p: 2, border: `1px dashed ${theme.palette.divider}`, borderRadius: 4 }}
            >
              <Grid container xs={12} spacing={2}>
                <Grid item xs={4}>
                  <label className="pb-8 block">*WGI List Price (Euros)</label>
                  <TextField
                    value={formData[activeStep]?.WG1Price || ''}
                    onChange={(e) => handleInputChange('WG1Price', e.target.value)}
                    name="WG1Price"
                    fullWidth
                    variant="outlined"
                    type="number"
                  />
                </Grid>
                <Grid item xs={4}>
                  <label className="pb-8 block">*WG2 List Price (Euros)</label>
                  <TextField
                    value={formData[activeStep]?.WG2Price || ''}
                    onChange={(e) => handleInputChange('WG2Price', e.target.value)}
                    name="WG2Price"
                    fullWidth
                    variant="outlined"
                    type="number"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>
      <Box
        sx={{
          display: "flex",
          p: 2,
          justifyContent: "flex-end",
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        {activeStep > 0 && (
          <Button
            color="secondary"
            onClick={handleBack}
            sx={{ mr: 1 }}
          >
            Back
          </Button>
        )}
        {activeStep < steps.length - 1 && (
          <Button variant="contained" color="primary" onClick={handleNext}>
            Next
          </Button>
        )}
        {activeStep === steps.length - 1 && (
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Submit
          </Button>
        )}
      </Box>
    </>
  );
};

export default TestOrder;
